// removed by extract-text-webpack-plugin
module.exports = {"title":"NQ1xg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AppHeader/Title/style.scss
// module id = kcdz
// module chunks = 0